/** @jsx jsx */
import { jsx } from '@emotion/core';
import style from './style';
import { SiteLink, useRouter } from 'components';
import { useState, useEffect } from 'react';
import env from 'env';
import { Redirect } from 'react-router-dom';
import { Loading } from 'components';

export function ResetPassword(props){
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [buttonTrigger, setButtonTrigger] = useState(0);
    const { query } = useRouter();
    const [msg, setMsg] = useState();
    const [redirect, setRedirect] = useState(false);
    const [pageLoading, setPageLoading] = useState(false);

    const token = query.u;
    
    // Check if passwords match
    const passwordsMatch = password && confirmPassword && password === confirmPassword;
    const passwordsEntered = password && confirmPassword;
    const canSubmit = passwordsMatch && password.length >= 6;

    function onSubmit(e) {
        e.preventDefault();   
        e.stopPropagation();
        setPageLoading(true);
        setButtonTrigger(buttonTrigger + 1);
    }

    useEffect(() => {
        if(buttonTrigger === 0){
            return;
        }
        const fetchData = async () => {
            const res = await fetch(env.apiBase + '/api/profile/resetpassword', {
                method : 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({password: password, token: token})
            });
            const data = await res.json();

            setMsg("You've successfully changed your password.")
            if(data.errors.length > 0){
                setMsg(data.errors[0].errorMessage);
            }
            else{
                setTimeout(() => {
                    setRedirect(true);    
                }, 1000);
            }
            setPageLoading(false);
        }
        fetchData();
        setButtonTrigger(0);
    }, [buttonTrigger, token, password]);

    return( 
        pageLoading ? <Loading /> :  
            <form css={style.formContainer} autoComplete="off" onSubmit = {onSubmit}>
            <h1 style={{textAlign:'center'}}>Reset Password</h1>
            <div className="form-group">
                <label htmlFor="password"> New Password </label>
                <div style={{ position: 'relative' }}>
                    <input 
                        id="password"
                        type={showPassword ? "text" : "password"}
                        className="form-control" 
                        required 
                        onChange={(e) => setPassword(e.target.value)} 
                        value={password}
                        style={{ paddingRight: '60px' }}
                    />
                    <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            border: 'none',
                            background: 'transparent',
                            color: '#666',
                            cursor: 'pointer',
                            fontSize: '14px',
                            padding: '5px'
                        }}
                    >
                        {showPassword ? 'Hide' : 'Show'}
                    </button>
                </div>
                {password && password.length < 6 && (
                    <small style={{ color: '#dc3545' }}>Password must be at least 6 characters</small>
                )}
            </div>

            <div className="form-group">
                <label htmlFor="confirmPassword"> Confirm Password </label>
                <div style={{ position: 'relative' }}>
                    <input 
                        id="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        className="form-control" 
                        required 
                        onChange={(e) => setConfirmPassword(e.target.value)} 
                        value={confirmPassword}
                        style={{ paddingRight: '60px' }}
                    />
                    <button
                        type="button"
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        style={{
                            position: 'absolute',
                            right: '10px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            border: 'none',
                            background: 'transparent',
                            color: '#666',
                            cursor: 'pointer',
                            fontSize: '14px',
                            padding: '5px'
                        }}
                    >
                        {showConfirmPassword ? 'Hide' : 'Show'}
                    </button>
                </div>
                {passwordsEntered && (
                    <div style={{ marginTop: '5px' }}>
                        {passwordsMatch ? (
                            <span style={{ color: '#28a745', fontWeight: 'bold' }}>✓ Passwords match</span>
                        ) : (
                            <span style={{ color: '#dc3545' }}>✗ Passwords do not match</span>
                        )}
                    </div>
                )}
            </div>

            {
                msg ? <div css={style.textContainer}>
                    <span css={style.msgStyle}>{msg}</span>
                </div> : null
            }
            
            <div className="form-group" style={{textAlign:'center'}}>
                <button 
                    css={style.buttonStyle} 
                    type="submit" 
                    className="btn btn-primary"
                    disabled={!canSubmit}
                    style={{ opacity: canSubmit ? 1 : 0.6 }}
                >
                    Reset Password
                </button>
            </div>
            <SiteLink to = "/login">
                Go back to Log in?
            </SiteLink>
            {
                redirect ? <Redirect to="/login"></Redirect> : null
            }
        </form>
    )
}